module.exports = __webpack_public_path__ + "static/media/logo_fly_id.fd4608de.png";